import parseCustomDateString from '~~/helpers/time/parseCustomDateString';

export default function isDateTodayOrFuture(inputDateString: string): boolean {

  const inputDate = parseCustomDateString(inputDateString);
  const currentUTC = new Date();

  return inputDate.getTime() >= currentUTC.getTime();

}
